import { UserType } from '../../entities';
import { AppSecurityRight, MobileTechniciansSecurityModule, MobileTechniciansSecurityRight, TaskSecurityRight } from '../modules';
import { SecurityRole, SecurityRoleType } from '../security.role';


export class EmployeeTechnician implements SecurityRole {

    _id = 'f1e7d5f3-6abf-4ab8-a4ea-6ffd1bd12ef1';
    system = true;
    hidden = false;
    name = SecurityRoleType.EmployeeTechnician;
    type = UserType.Employee;
    description = 'Access to technician board only. Can work on a job, but can not create or delete.';
    rights = [
        AppSecurityRight.LoginField,
        ...new MobileTechniciansSecurityModule().allExceptRights([
            MobileTechniciansSecurityRight.CanTakePayments,
            MobileTechniciansSecurityRight.ModifyFormAfterSubmission
        ]),
        ...[TaskSecurityRight.CanAccess, TaskSecurityRight.ManageManualTasks, TaskSecurityRight.DeleteMyTasks,
        ]
    ];

}

